import { IProductWithState } from '@cbgms/api'
import { getUniqueId as origGetUniqueID } from '@cbgms/components/src/order-list/context/filters/ProductFiltersReducer'

export const getUniqueId = origGetUniqueID

export const areEqualProducts = (i1: IProductWithState, i2: IProductWithState) => {
  return getUniqueId(i1) === getUniqueId(i2)
}
